import React from "react";
import siteConfig from "../config/siteConfig";
import "../css/terms.scss";

function Terms() {
  return (
    <main className="policy-page terms">
      <header>
        <p className="eyebrow">Legal</p>
        <h1>Terms &amp; conditions</h1>
        <p>
          These terms describe use of the {siteConfig.displayName} storefront and
          the basis on which orders would be accepted by a connected commerce
          service. This storefront is operated by {siteConfig.legalEntity.name},
          registered at {siteConfig.legalEntity.address}.
        </p>
        <small>Last updated: 14 August 2026</small>
      </header>
      <article className="policy-copy">
        <section>
          <h2>Storefront use</h2>
          <p>
            You may browse and use this storefront for personal, lawful shopping.
            Product copy, layouts and original imagery may not be republished or
            used commercially without permission.
          </p>
        </section>
        <section>
          <h2>Products &amp; availability</h2>
          <p>
            We aim to show colour, proportion and material accurately, though
            screens can vary. Availability is not guaranteed until an order is
            confirmed. Limited-run pieces may sell out without notice.
          </p>
        </section>
        <section>
          <h2>Orders &amp; payment</h2>
          <p>
            Prices are displayed in {siteConfig.currency.code} and include
            applicable VAT where stated. An order is accepted only after payment
            authorisation and a confirmation is issued. This project is a
            frontend demonstration and does not transmit or settle payments.
          </p>
        </section>
        <section>
          <h2>Delivery &amp; returns</h2>
          <p>
            Delivery estimates are not guarantees. Eligible unworn pieces may be
            returned within {siteConfig.commerce.returnsWindowDays} days, subject
            to the conditions in our returns policy.
          </p>
        </section>
        <section>
          <h2>Liability</h2>
          <p>
            Nothing in these terms excludes rights or liabilities that cannot be
            excluded by law. Otherwise, liability is limited to the value of the
            relevant order to the extent legally permitted.
          </p>
        </section>
        <section>
          <h2>Questions</h2>
          <p>
            Contact <a href={`mailto:${siteConfig.contact.email}`}>{siteConfig.contact.email}</a> for assistance.
          </p>
        </section>
      </article>
    </main>
  );
}

export default Terms;
